import React from 'react';
import { ColumnList } from '../../../../../../wag-react/components/ColumnList';
import { Link } from '../../../../../../wag-react/core-components/link';
import { Box } from '../../../../../../components/Box';
import { Typography } from '../../../../../../components/Typography';
import { URL_CITY_DIRECTORY } from '../../../../../../constants';
import { buildCols } from '../../../../../../utils';
import { cities } from '../../data';
import { useMediaQuery } from '../../../../../../hooks/useMediaQuery';
import { pxToNumber } from '../../../../../../wag-react/common/utils/pxToNumber';
import { theme } from '../../../../../../wag-react/themes/base-theme';
export const CityList = () => {
  const smBreakpoint = pxToNumber(theme.breakpoints[1]);
  const {
    matched: isMobile
  } = useMediaQuery({
    maxWidth: smBreakpoint - 1
  });
  const NUM_COLS_DESKTOP = 6;
  const NUM_COLS_MOBILE = 2;
  const createCityDOMList = () => {
    const cityDOMList = cities.map(city => <Box p={["12px 12px 12px 0px", "12px", "12px"]} alignItems="center" key={city.slug}>
        <Link href={URL_CITY_DIRECTORY({
        state: city.stateAbbrev.toLowerCase(),
        city: city.slug.toLowerCase()
      })}>
          <Typography color="#222" fontSize="14px" lineHeight="24px" letterSpacing="0px" fontStyle="normal" fontWeight={600} mb={0} hover style={{
          fontFamily: '"Hero New", sans-serif'
        }}>
            {`${city.city}, ${city.stateAbbrev}`}
          </Typography>

          <Typography color="#474747" fontSize="12px" lineHeight="20px" letterSpacing="0px" fontStyle="normal" fontWeight={400} m={0} hover style={{
          fontFamily: '"Hero New", sans-serif'
        }}>
            {`${city.numCaregivers} Pet Caregivers`}
          </Typography>
        </Link>
      </Box>);
    return cityDOMList;
  };
  return <Box width={1} data-sentry-element="Box" data-sentry-component="CityList" data-sentry-source-file="CityList.tsx">
      {isMobile ? <ColumnList cols={buildCols(NUM_COLS_MOBILE, createCityDOMList())} /> : null}
      {!isMobile ? <ColumnList cols={buildCols(NUM_COLS_DESKTOP, createCityDOMList())} /> : null}
    </Box>;
};